<template>
  <div v-if="country">
    <country-details :data-country.sync="country" @update:dataCountry="updateCountry" />
    <transaction-fees
      class="mt-3"
      :fees_url="`/api/v1/transactions/transferCountries/${country.id}/fees`"
    />
    <receiving-countries class="mt-3" :country_id="id" />
    <cash-in-methods class="mt-3" :country_id="id" />
    <cashout-methods class="mt-3" :country_id="id" />
    <cities-and-quarters
      class="mt-3"
      :country-id="id"
      :data="country.city_quarters || {}"
    ></cities-and-quarters>
  </div>
</template>

<script>
import TransactionFees from "../fees";
import CountryDetails from "./details";
import ReceivingCountries from "./receivingCountries";
import CashInMethods from "./cashInMethods";
import CashoutMethods from "./cashoutMethods";
import CitiesAndQuarters from "./citiesAndQuarters";

export default {
  props: {
    id: {
      required: true,
    },
  },
  components: {
    TransactionFees,
    CountryDetails,
    ReceivingCountries,
    CashInMethods,
    CashoutMethods,
    CitiesAndQuarters,
  },
  data: () => ({
    country: null,
  }),
  mounted() {
    this.fetchCountry();
  },
  watch: {
    id() {
      this.fetchCountry();
    },
  },
  methods: {
    fetchCountry() {
      this.$http
        .get(`/api/v1/transactions/transferCountries/${this.id}`)
        .then((country) => (this.country = country));
    },
    updateCountry(country) {
      if (country) {
        this.country = country;
      }
    },
  },
};
</script>

<style></style>
